<template>
    <div class="audio-player">
        <!-- 原生 audio 元素，隐藏默认控件 -->
        <audio
            ref="audio"
            :src="src"
            @loadedmetadata="onLoadedMetadata"
            @timeupdate="onTimeUpdate"
            @ended="onEnded"
            @error="onError"
        ></audio>

        <!-- 自定义控制面板：播放按钮 + 进度条 + 时间 -->
        <div class="controls">
            <!-- 播放/暂停按钮 -->
            <button @click="togglePlay" class="btn-play">
                {{ isPlaying ? '⏸' : '▶️' }}
            </button>

            <!-- 进度条 -->
            <div class="progress-container" @click="setProgress">
                <div class="progress-bar" :style="{ width: progressPercent + '%' }"></div>
            </div>

            <!-- 时间显示 -->
            <span class="time">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AudioPlayer',
    props: {
        src: {
            type: String,
            required: true
        },
        autoplay: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isPlaying: false,
            currentTime: 0,
            duration: 0,
            progressPercent: 0
        };
    },
    watch: {
        src(newSrc, oldSrc) {
            if (newSrc !== oldSrc) {
                const audio = this.$refs.audio;
                audio.load();
                if (this.autoplay) {
                    audio.play().catch(() => {
                    });
                }
            }
        }
    },
    mounted() {
        if (this.autoplay) {
            this.$refs.audio.play().catch(() => {
            });
        }
    },
    methods: {
        togglePlay() {
            const audio = this.$refs.audio;
            if (this.isPlaying) {
                audio.pause();
            } else {
                audio.play().catch((err) => {
                    console.warn('播放失败:', err);
                });
            }
            this.isPlaying = !this.isPlaying;
        },
        onLoadedMetadata() {
            this.duration = this.$refs.audio.duration;
        },
        onTimeUpdate() {
            const audio = this.$refs.audio;
            this.currentTime = audio.currentTime;
            this.progressPercent = (this.currentTime / this.duration) * 100 || 0;
        },
        onEnded() {
            this.isPlaying = false;
            this.currentTime = 0;
            this.progressPercent = 0;
        },
        onError(e) {
            console.error('音频加载失败:', e);
            this.$emit('error', e);
        },
        setProgress(e) {
            const container = e.currentTarget;
            const rect = container.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const percent = Math.min(Math.max(x / rect.width, 0), 1);
            const audio = this.$refs.audio;
            audio.currentTime = percent * this.duration;
            this.currentTime = percent * this.duration;
            this.progressPercent = percent * 100;
        },
        formatTime(seconds) {
            if (isNaN(seconds) || seconds === Infinity) return '00:00';
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
        }
    }
};
</script>

<style scoped>
.audio-player {
    display: flex;
    align-items: center;
    padding: 8px 8px 8px 0; /* 无背景色，仅保留少量内边距 */
    font-family: Arial, sans-serif;
    user-select: none;
    width: 240px;
    background: #f8f8f8;
}

.controls {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 12px;
}

.btn-play {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    padding: 0 4px;
    transition: transform 0.2s;
    flex-shrink: 0; /* 防止按钮被压缩 */
}

.btn-play:hover {
    transform: scale(1.1);
}

.progress-container {
    flex: 1;
    height: 6px;
    background: #d0d0d0;
    border-radius: 3px;
    cursor: pointer;
    position: relative;
    min-width: 60px;
}

.progress-bar {
    height: 100%;
    background: #4caf50;
    border-radius: 3px;
    transition: width 0.1s linear;
    pointer-events: none;
}

.time {
    font-size: 14px;
    color: #555;
    min-width: 90px;
    text-align: center;
    flex-shrink: 0;
}
</style>